/**
 * author: duxin
 * date: 2020/4/3
 * describe:
 */

import VueRouter from "vue-router"
import vue from "vue"

vue.use(VueRouter);
const routes = [
    {
        path: '/',
        component: () => import('../views/index.vue'),
        redirect: "/home",
        children: [
            {
                path: 'home',
                name: 'HOME',
                component: () => import('../views/home/index.vue'),
                children: [
                    {
                        path: 'service',
                        name: 'SERVICE',
                        component: () => import('../views/home/chunks/me-service-chunk'),
                    },
                    {
                        path: 'course',
                        name: 'COURSE',
                        component: () => import('../views/home/chunks/course-chunk'),
                    },
                    {
                        path: 'team',
                        name: 'TEAM',
                        component: () => import('../views/home/chunks/team-chunk'),
                    },
                    {
                        path: 'culture',
                        name: 'CULTURE',
                        component: () => import('../views/home/chunks/culture-chunk'),
                    },
                    {
                        path: 'news',
                        name: 'NEWS',
                        component: () => import('../views/home/chunks/me-news-chunk'),
                    }
                ]
            },
            {
                path: 'service',
                component: () => import('../views/service/index.vue'),
                redirect: "/service/clinical",
                children: [
                    {
                        path: 'dm',
                        name: 'DM',
                        component: () => import('../views/service/dm.vue'),
                    },
                    {
                        path: 'biostatistics',
                        name: 'BIOSTATISTICS',
                        component: () => import('../views/service/biostatistics.vue'),
                    },
                    {
                        path: 'sp',
                        name: 'SP',
                        component: () => import('../views/service/sp.vue'),
                    },
                    {
                        path: 'pharmacovigilance',
                        name: 'PHARMACOVIGILANCE',
                        component: () => import('../views/service/pharmacovigilance.vue'),
                    },
                    {
                        path: 'cc',
                        name: 'CC',
                        component: () => import('../views/service/cc.vue'),
                    }
                ]
            },
            {
                path: 'about',
                redirect: "/about/company",
                component: () => import('../views/about/index.vue'),
                children: [
                    {
                        path: 'company',
                        name: 'COMPANYS',
                        component: () => import('../views/about/company.vue'),
                    },
                    {
                        path: 'detail',
                        name: 'DETAIL',
                        component: () => import('../views/about/detail.vue'),
                    },
                    {
                        path: 'application',
                        name: 'APPLICATION',
                        component: () => import('../views/about/application.vue'),
                    },
                ]
            },
            {
                path: 'join',
                name: 'join',
                component: () => import('../views/join/join-us.vue'),
            },
            {
                path: 'contact',
                name: 'contact',
                component: () => import('../views/contact/contact-us.vue'),
            },
            {
                path: 'info',
                redirect: "/info/company",
                component: () => import('../views/information/index.vue'),
                children: [
                    {
                        path: 'company',
                        name: 'COMPANY',
                        component: () => import('../views/information/company.vue'),
                    },
                    {
                        path: 'industry',
                        name: 'INDUSTRY',
                        component: () => import('../views/information/industry.vue'),
                    },
                    // {
                    //     path: 'book',
                    //     name: 'BOOK',
                    //     component: () => import('../views/information/books.vue'),
                    // },
                    {
                        path: 'honor',
                        name: 'HONOR',
                        component: () => import('../views/information/honor.vue'),
                    },
                    {
                        path: 'web',
                        name: 'WEB',
                        component: () => import('../views/information/web-page.vue'),
                    }
                ]
            },
        ]
    },
    { // 404
        path: '*',
        name: 'Error',
        meta: {
            title: '404-页面不存在'
        },
        component: () => import('../views/error'),
    },
    // 媒体
    {
        path: '*',
        name: 'MEDIA',
        component: () => import('../views/media/media'),
    }
];


const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL,
});
// 跳转后回到页面顶部
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
})
export default router